import { RootState } from "redux/rootReducer";

export const selectIsDeletingPatient = (state: RootState) =>
  state.deletePatient.loading;
export const selectDeletePatientErrorMessage = (state: RootState) =>
  state.deletePatient.error;
export const deletePatientResponse = (state: RootState) =>
  state.deletePatient.deletePatientResponse;
